import LXCenter from '../core/components/center';
import ForgetForm from './components/forgetForm';

const ForgetPage: React.FC = () => {
  return (
    <LXCenter>
      <ForgetForm />
    </LXCenter>
  );
};

export default ForgetPage;
